import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {Subscription} from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {MailConfigurationInterface} from '../../../class/api/MailConfiguration';
import {AideInterface} from '../../../class/api/Aide';
import {HydraService} from '../../../core/services/hydra.service';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {api} from '../../../api/api-dictionnary';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MailCodeInterface} from '../../../class/api/MailCode';
import {CommissionSeanceInterface} from '../../../class/api/CommissionSeance';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDivider } from '@angular/material/divider';
import { KeyValuePipe } from '@angular/common';
import { MatSelectionList, MatListSubheaderCssMatStyler, MatListOption, MatListItemAvatar, MatListItemTitle, MatListItemLine } from '@angular/material/list';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-declinaison-notification',
    templateUrl: './modal-declinaison-notification.component.html',
    styleUrls: ['./modal-declinaison-notification.component.scss'],
    imports: [CdkScrollable, MatDialogContent, MatDialogTitle, MatDivider, FormsModule, ReactiveFormsModule, MatSelectionList, MatListSubheaderCssMatStyler, MatListOption, MatListItemAvatar, MatListItemTitle, MatListItemLine, MatDialogActions, MatButton, MatDialogClose, KeyValuePipe]
})
export class ModalDeclinaisonNotificationComponent implements OnInit, OnDestroy {
    data = inject<{
    notification: MailConfigurationInterface;
    commissionSeance: CommissionSeanceInterface;
    aap: AideInterface;
}>(MAT_DIALOG_DATA);
    private translateService = inject(TranslateService);
    private hydraService = inject(HydraService);


    private subscriptions: Subscription[] = [];
    public notificationsEligibles: {
        [typeSpecificite: string]: {
            label: string;
            notifications: {
                mailCode: MailCodeInterface;
                label: string;
                description: string;
                avatar: string | null;
                cs: string | null;
                csDecisive: boolean;
            }[];
        };
    } = {};

    public form: FormGroup;

    private labelsMap = {
        G: 'Générique',
        AAP: 'Spécifique à un AAP',
        T: 'Spécifique à un type d\'AAP',
        C: 'Spécifique à une catégorie d\'AAP',
    };

    constructor() {

        this.form = new FormGroup(
            {
                notificationsForm: new FormControl<MailConfigurationInterface[]>([], Validators.required)
            }
        );
    }

    ngOnInit(): void {
        if (!this.data.notification) {
            return;
        }
        if (!this.data.aap) {
            return;
        }

        const mailCode = this.data.notification.mailCode;
        if (!mailCode || typeof mailCode === 'string') {
            return;
        }

        this.subscriptions.push(
            this.hydraService.getList(api.mailConfigurations + '?enabled=1&mailCode=' + mailCode.code)
                .subscribe(
                    (res: HydraCollection) => {
                        this.notificationsEligibles = res.getMember()
                            .map(item => ({
                                    ...item,
                                    description: (item.aide?.label) ?? (item.aideSousType?.label) ?? (item.aideType?.label) ?? 'Générique',
                                    cs: item.commissionSeance?.label ? item.commissionSeance?.label : null,
                                    csDecisive: item.commissionSeance ? item.commissionSeance.decisiveStatutDossier : false
                                })).reduce(
                                (obj, item) => {

                                    const index = item.aide ? 'AAP' : item.aideSousType ? 'T' : item.aideType ? 'C' : 'G';
                                    item.avatar = index;

                                    if (!obj[index]) {
                                        obj[index] = {
                                            label: this.labelsMap[index],
                                            notifications: [item]
                                        };
                                    } else {
                                        obj[index].notifications.push(item);
                                    }

                                    return obj;
                                },
                                this.notificationsEligibles
                            );
                    }
                )
        );

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(item => item.unsubscribe());
    }

}
